<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { CriterionDeleterViewModel } from "@Criteria/Hierarchies/Components/CriterionDeleter";
    import { DependentEntityInfo } from "@common/types";
    import { dynamicUiRoutes } from "@common/dynamicUiRoutes";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CriterionDeleter extends Vue
    {
        get vm(): CriterionDeleterViewModel { return this.$props.viewModel as CriterionDeleterViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get initialized(): boolean { return this.vm.data != null; }
        get criterionId(): number { return this.vm.criterionId; }
        get hasDependants(): boolean { return this.vm.data?.HasDependants; }
        get criterionName(): string { return this.vm.data?.Name; }
        get dependenciesCount(): number { return this.vm.data?.DependenciesCount; }
        get weightedScores(): DependentEntityInfo[] { return this.vm.data?.WeightedScores; }

        url_EditWeightedScorePage(e: DependentEntityInfo)
        {
            return dynamicUiRoutes.Criteria_EditWeightedScorePage2(this.$route, e.WorkspaceId, e.TchProjectId, Number.parseInt(e.Id))
        }


        emitDeleteCriterion()
        {
            this.$emit("delete-criterion", this.criterionId);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div v-if="!initialized" class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete criterion</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <h4><i class="fa fa-spinner fa-spin"></i> Checking dependencies...</h4>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>

            <div v-if="initialized && hasDependants" class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete criterion</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="alert alert-danger text-dark" role="alert">
                            <h5 class="alert-heading">Cannot delete this criterion</h5>
                            <p>
                                The criterion '<strong>{{criterionName}}</strong>' is used in <strong>{{dependenciesCount}}</strong> places.
                                To delete this criterion, first remove it from where it is used.
                            </p>
                        </div>
                        <div>
                            <div class="card" v-if="weightedScores.length > 0">
                                <div class="card-header">
                                    Weighted scores (<span>{{weightedScores.length}}</span>)
                                </div>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item" v-for="ws in weightedScores" :key="ws.Id">
                                        <a class="text-primary" v-sanitizedHref="url_EditWeightedScorePage(ws)">{{ws.Name}}</a><br />
                                        <small class="text-muted">{{ws.Path}}</small>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>

            <div v-if="initialized && !hasDependants" class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header bg-danger text-white">
                        <h5 class="modal-title">Delete criterion</h5>
                        <button type="button" class="close text-white" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h4>Are you sure you want to delete this criterion?</h4>
                        <p>You are about to delete '<strong>{{criterionName}}</strong>'. Deleting a criterion will also delete its <strong>sub-criteria</strong>. This can't be undone.</p>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="emitDeleteCriterion" class="btn btn-danger">Delete</button>
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>